
import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Switch
} from '../../ui/ot'
import { useTranslation } from "react-i18next";

const LibraryForm = ({
    propsForm,
    field,
    formReloadCount = 0,
    onFormFinish = () => { },
    keyPrefix = "koha.library",

}) => {

    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const axiosMode = Form.useWatch([field?.name ?? '', 'axiosMode'].join('.'), form)
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
    };


    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                axiosMode={axiosMode}
                                field={field}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={form.setFieldValue}
                                setCount={setCount}
                                keyPrefix={keyPrefix}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    field,
    initialValues = {},
    keyPrefix = "library",
    axiosMode
}) => {
    const { t } = useTranslation('translation', { keyPrefix })

    return (
        <>
            <Row>
                <Col span={12}>
                    <Row>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchcode']}
                                fieldKey={[field?.fieldKey ?? '', 'branchcode']}
                                label={t('branchcode')}
                                initialValue={initialValues?.branchcode}
                                rules={[{ required: true, message: 'Please input name' }]}
                            >

                                <Input disabled={axiosMode === "patch"} />
                            </Form.Item>
                        </Col>

                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchname']}
                                fieldKey={[field?.fieldKey ?? '', 'branchname']}
                                label={t('branchname')}
                                initialValue={initialValues?.branchname}
                                rules={[{ required: true, message: 'Please input name' }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchaddress1']}
                                fieldKey={[field?.fieldKey ?? '', 'branchaddress1']}
                                label={t('branchaddress1')}
                                initialValue={initialValues?.branchaddress1}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchaddress2']}
                                fieldKey={[field?.fieldKey ?? '', 'branchaddress2']}
                                label={t('branchaddress2')}
                                hidden={true}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchaddress3']}
                                fieldKey={[field?.fieldKey ?? '', 'branchaddress3']}
                                label={t('branchaddress3')}
                                hidden={true}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchzip']}
                                fieldKey={[field?.fieldKey ?? '', 'branchzip']}
                                label={t('branchzip')}
                                initialValue={initialValues?.branchzip}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchcity']}
                                fieldKey={[field?.fieldKey ?? '', 'branchcity']}
                                label={t('branchcity')}
                                initialValue={initialValues?.branchcity}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchstate']}
                                fieldKey={[field?.fieldKey ?? '', 'branchstate']}
                                label={t('branchstate')}
                                initialValue={initialValues?.branchstate}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchcountry']}
                                fieldKey={[field?.fieldKey ?? '', 'branchcountry']}
                                label={t('branchcountry')}
                                initialValue={initialValues?.branchcountry}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchphone']}
                                fieldKey={[field?.fieldKey ?? '', 'branchphone']}
                                label={t('branchphone')}
                                initialValue={initialValues?.branchphone}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchfax']}
                                fieldKey={[field?.fieldKey ?? '', 'branchfax']}
                                label={t('branchfax')}
                                initialValue={initialValues?.branchfax}
                            >
                                <Input />
                            </Form.Item>
                        </Col>


                    </Row>
                </Col>
                <Col span={12}>
                    <Row>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchemail']}
                                fieldKey={[field?.fieldKey ?? '', 'branchemail']}
                                label={t('branchemail')}
                                initialValue={initialValues?.branchemail}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchillemail']}
                                fieldKey={[field?.fieldKey ?? '', 'branchillemail']}
                                label={t('branchillemail')}
                                initialValue={initialValues?.branchillemail}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchreplyto']}
                                fieldKey={[field?.fieldKey ?? '', 'branchreplyto']}
                                label={t('branchreplyto')}
                                initialValue={initialValues?.branchreplyto}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchurl']}
                                fieldKey={[field?.fieldKey ?? '', 'branchurl']}
                                label={t('branchurl')}
                                initialValue={initialValues?.branchurl}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        {/* <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'issuing']}
                                fieldKey={[field?.fieldKey ?? '', 'issuing']}
                                label={t('issuing')}
                                initialValue={initialValues?.issuing}
                            >
                                <Input />
                            </Form.Item>
                        </Col> */}
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchip']}
                                fieldKey={[field?.fieldKey ?? '', 'branchip']}
                                label={t('branchip')}
                                initialValue={initialValues?.branchip}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        {/* <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'geolocation']}
                                fieldKey={[field?.fieldKey ?? '', 'geolocation']}
                                label={t('geolocation')}
                                initialValue={initialValues?.geolocation}
                            >
                                <Input />
                            </Form.Item>
                        </Col> */}
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'branchnotes']}
                                fieldKey={[field?.fieldKey ?? '', 'branchnotes']}
                                label={t('branchnotes')}
                                initialValue={initialValues?.branchnotes}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'marcorgcode']}
                                fieldKey={[field?.fieldKey ?? '', 'marcorgcode']}
                                label={t('marcorgcode')}
                                initialValue={initialValues?.marcorgcode}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'pickup_location']}
                                fieldKey={[field?.fieldKey ?? '', 'pickup_location']}
                                label={t('pickup_location')}
                                initialValue={initialValues?.pickup_location}
                            >
                                <Switch 
                                 checkedChildren={t('yes')}
                                 unCheckedChildren={t('no')}
                                mode='number' />

                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'public']}
                                fieldKey={[field?.fieldKey ?? '', 'public']}
                                label={t('public')}
                                initialValue={initialValues?.public}
                            >
                                <Switch
                                    checkedChildren={t('yes')}
                                    unCheckedChildren={t('no')}
                                    mode='number' />
                            </Form.Item>
                        </Col>
                        {/* <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'opacuserjs']}
                                fieldKey={[field?.fieldKey ?? '', 'opacuserjs']}
                                label={t('opacuserjs')}
                                initialValue={initialValues?.opacuserjs}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24} >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                {...field}
                                name={[field?.name ?? '', 'opacusercss']}
                                fieldKey={[field?.fieldKey ?? '', 'opacusercss']}
                                label={t('opacusercss')}
                                initialValue={initialValues?.opacusercss}
                            >
                                <Input />
                            </Form.Item>
                        </Col> */}
                    </Row>
                </Col>
            </Row>
        </>
    );
};

let aaa= '"<h4 style=""box-sizing: border-box; margin-top: 0px; margin-bottom: 0.5rem; font-weight: 500; line-height: 1.2; font-size: 1.5rem; color: rgb(37, 37, 37); font-family: &quot;Open Sans&quot;, sans-serif; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; letter-spacing: normal; orphans: 2; text-align: left; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal;  text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;""><span style=""box-sizing: border-box;""><strong style=""box-sizing: border-box; font-weight: bolder;"">99年國科會補助「性別與科技研究計畫」</strong></span></h4><p style=""box-sizing: border-box; margin-top: 0px; margin-bottom: 1rem; color: rgb(37, 37, 37); font-family: &quot;Open Sans&quot;, sans-serif; font-size: 18px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: left; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal;  text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;""><span style=""box-sizing: border-box;"">資料來源：國科會學術補助獎勵查詢&nbsp;<a href=""https://wsts.nstc.gov.tw/STSWeb/Award/AwardMultiQuery.aspx"" target=""_blank"" rel=""noopener"" data-mce-href=""https://wsts.nstc.gov.tw/STSWeb/Award/AwardMultiQuery.aspx"" style=""box-sizing: border-box; color: rgb(3, 69, 191); text-decoration: none; transition: color 400ms, background-color 400ms; word-break: break-word;"">https://wsts.nstc.gov.tw/STSWeb/Award/AwardMultiQuery.aspx</a></span></p><table class=""mce-item-table"" style=""box-sizing: border-box; caption-side: bottom; border-collapse: collapse; color: rgb(37, 37, 37); font-family: &quot;Open Sans&quot;, sans-serif; font-size: 18px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: left; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; white-space: normal;  text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;""><thead style=""box-sizing: border-box; border-color: inherit; border-style: solid; border-width: 0px;""><tr data-mce-style=""border-bottom: 1px #000000 solid;"" style=""box-sizing: border-box; border-top-color: inherit; border-right-color: inherit; border-bottom: 1px solid rgb(0, 0, 0); border-left-color: inherit; border-top-style: solid; border-right-style: solid; border-left-style: solid; border-top-width: 0px; border-right-width: 0px; border-left-width: 0px;""><th data-mce-style=""width: 10%;"" style=""box-sizing: border-box; text-align: -webkit-match-parent; border-color: inherit; border-style: solid; border-width: 0px; width: 98px;""><span style=""box-sizing: border-box;""><strong style=""box-sizing: border-box; font-weight: bolder;"">篇次</strong></span></th><th data-mce-style=""width: 10%;"" style=""box-sizing: border-box; text-align: -webkit-match-parent; border-color: inherit; border-style: solid; border-width: 0px; width: 98px;""><span style=""box-sizing: border-box;""><strong style=""box-sizing: border-box; font-weight: bolder;"">主持人</strong></span></th><th data-mce-style=""width: 20%;"" style=""box-sizing: border-box; text-align: -webkit-match-parent; border-color: inherit; border-style: solid; border-width: 0px; width: 196px;""><span style=""box-sizing: border-box;""><strong style=""box-sizing: border-box; font-weight: bolder;"">執行機關</strong></span></th><th data-mce-style=""width: 50%;"" style=""box-sizing: border-box; text-align: -webkit-match-parent; border-color: inherit; border-style: solid; border-width: 0px; width: 490px;""><span style=""box-sizing: border-box;""><strong style=""box-sizing: border-box; font-weight: bolder;"">計畫名稱</strong></span></th><th data-mce-style=""width: 10%;"" style=""box-sizing: border-box; text-align: -webkit-match-parent; border-color: inherit; border-style: solid; border-width: 0px; width: 98px;""><span style=""box-sizing: border-box;""><strong style=""box-sizing: border-box; font-weight: bolder;"">成果報告</strong></span></th></tr></thead><tbody style=""box-sizing: border-box; border-color: inherit; border-style: solid; border-width: 0px;""><tr data-mce-style=""border-bottom: 1px #000000 solid;"" style=""box-sizing: border-box; border-top-color: inherit; border-right-color: inherit; border-bottom: 1px solid rgb(0, 0, 0); border-left-color: inherit; border-top-style: solid; border-right-style: solid; border-left-style: solid; border-top-width: 0px; border-right-width: 0px; border-left-width: 0px;""><td style=""box-sizing: border-box; border-color: inherit; border-style: solid; border-width: 0px;""><span style=""box-sizing: border-box;"">1</span></td><td style=""box-sizing: border-box; border-color: inherit; border-style: solid; border-width: 0px;""><span style=""box-sizing: border-box;"">吳嘉麗</span></td><td style=""box-sizing: border-box; border-color: inherit; border-style: solid; border-width: 0px;""><span style=""box-sizing: border-box;"">淡江大學化學系</span></td><td style=""box-sizing: border-box; border-color: inherit; border-style: solid; border-width: 0px;""><div style=""box-sizing: border-box;""><strong style=""box-sizing: border-box; font-weight: bolder;"">理工科系性別文化探究（第 2 年）</strong></div><div style=""box-sizing: border-box;""><span style=""box-sizing: border-box;"">研究型別: 整合型（理工科系性別文化探究）</span></div><div style=""box-sizing: border-box;""><span style=""box-sizing: border-box;"">補助金額: 3156000</span></div><div style=""box-sizing: border-box;""><span style=""box-sizing: border-box;"">執行期限: 2010/08/01~2012/09/30</span></div></td><td style=""box-sizing: border-box; border-color: inherit; border-style: solid; border-width: 0px;""><span style=""box-sizing: border-box;""><a href=""https://taiwan-gist.nknu.edu.tw/images/2.%20nstc%20gender%20and%20technology%20project%20reports/99/99-1.pdf"" target=""_blank"" rel=""noopener"" data-mce-href=""images/2.%20nstc%20gender%20and%20technology%20project%20reports/99/99-1.pdf"" style=""box-sizing: border-box; color: rgb(3, 69, 191); text-decoration: none; transition: color 400ms, background-color 400ms; word-break: break-word;""><img src=""https://lh3.googleusercontent.com/kmLmrxiBjqTFQn-1QQzZQpVjb5Y0r8LuBH0IIDcgAAQ7_cOujT_fkM5czkwilzVJpxB2=w170"" alt="""" data-mce-src=""https://lh3.googleusercontent.com/kmLmrxiBjqTFQn-1QQzZQpVjb5Y0r8LuBH0IIDcgAAQ7_cOujT_fkM5czkwilzVJpxB2=w170"" style=""box-sizing: border-box; vertical-align: middle; display: block; max-width: 100%; height: auto;""></a><strong style=""box-sizing: border-box; font-weight: bolder;""><span data-mce-empty=""1"" data-mce-style=""color: #d40000;"" style=""box-sizing: border-box; color: rgb(212, 0, 0);"">&nbsp;</span></strong></span></td></tr><tr style=""box-sizing: border-box; border-color: inherit; border-style: solid; border-width: 0px;""><td style=""box-sizing: border-box; border-color: inherit; border-style: solid; border-width: 0px;""><span style=""box-sizing: border-box;"">2</span></td><td style=""box-sizing: border-box; border-color: inherit; border-style: solid; border-width: 0px;""><span style=""box-sizing: border-box;"">許樹珍</span></td><td style=""box-sizing: border-box; border-color: inherit; border-style: solid; border-width: 0px;""><span style=""box-sizing: border-box;"">國立陽明大學護理學系暨研究所</span></td><td style=""box-sizing: border-box; border-color: inherit; border-style: solid; border-width: 0px;""><div style=""box-sizing: border-box;""><strong style=""box-sizing: border-box; font-weight: bolder;"">疑似乳癌婦女手術認知與醫療自主決策之探索和促進方案—疑似乳癌婦女醫療自主與手術決策過程之探討（第 2 年）</strong></div><div style=""box-sizing: border-box;""><span style=""box-sizing: border-box;"">研究型別: 整合型（疑似乳癌婦女手術認知與醫療自主決策之探索和促進方案）</span></div><div style=""box-sizing: border-box;""><span style=""box-sizing: border-box;"">補助金額: 2000000</span></div><div style=""box-sizing: border-box;""><span style=""box-sizing: border-box;"">執行期限: 2010/08/01~2013/07/31</span></div></td><td style=""box-sizing: border-box; border-color: inherit; border-style: solid; border-width: 0px;""><span style=""box-sizing: border-box;""><a href=""https://taiwan-gist.nknu.edu.tw/images/2.%20nstc%20gender%20and%20technology%20project%20reports/99/99-2.pdf"" target=""_blank"" rel=""noopener"" data-mce-href=""images/2.%20nstc%20gender%20and%20technology%20project%20reports/99/99-2.pdf"" data-mce-selected=""inline-boundary"" style=""box-sizing: border-box; color: rgb(4, 76, 208); text-decoration: none; transition: color 400ms, background-color 400ms; word-break: break-word;""><img src=""https://lh3.googleusercontent.com/kmLmrxiBjqTFQn-1QQzZQpVjb5Y0r8LuBH0IIDcgAAQ7_cOujT_fkM5czkwilzVJpxB2=w170"" alt="""" data-mce-src=""https://lh3.googleusercontent.com/kmLmrxiBjqTFQn-1QQzZQpVjb5Y0r8LuBH0IIDcgAAQ7_cOujT_fkM5czkwilzVJpxB2=w170"" style=""box-sizing: border-box; vertical-align: middle; display: block; max-width: 100%; height: auto;""></a></span></td></tr></tbody></table><br class=""Apple-interchange-newline"">"'



export default LibraryForm;
